module.exports = __webpack_public_path__ + "static/img/bcg.eff63788.png";